import React, { useState } from "react";
import server from "api/server";
import { FormattedMessage } from "react-intl";
import imageUpload from "assets/svgs/imageUpload.svg";
import removeImg from "assets/svgs/close.svg";
import "./DragDropUploader.css"

// Drag-and-Drop Uploader Component
const DragDropUploader = ({ selectedImages, setSelectedImages }) => {
  const [dragging, setDragging] = useState(false);

  const handleFileDrop = async (e) => {
    e.preventDefault();
    setDragging(false);

    const files = Array.from(e.dataTransfer.files);
    handleFilesUpload(files);
  };

  const handleFilesUpload = async (files) => {
    const uploadedImages = [];

    for (const file of files) {
      const formData = new FormData();
      formData.append("file", file);

      try {
        const { data } = await server().post("/upload", formData);
        uploadedImages.push({
          preview: URL.createObjectURL(file),
          path: process.env.REACT_APP_URL + data.data.file.path,
        });
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    }
    console.log(uploadedImages);
    setSelectedImages((prevImages) => [...prevImages, ...uploadedImages]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragging(false);
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    handleFilesUpload(files);
  };

  const removeImage = (index) => {
    setSelectedImages((prevImages) =>
      prevImages.filter((_, imgIndex) => imgIndex !== index)
    );
  };

  return (
    <div
      className={`drag-drop-uploader mb-5 ${dragging ? "dragging" : ""}`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleFileDrop}
    >
      <div className="upload-area ">
        <div className="image-uploader image-contain m-0 p-0">
          <div className="img-pat">
            <img src={imageUpload} width={46} height={46} alt="Upload Icon" />

          </div>
        </div>
        <span>
          <FormattedMessage id="dragDropFiles" />
        </span>
        <span> <FormattedMessage id="or" defaultMessage="or" /></span>
        <label className="upload-label">
          <FormattedMessage id="browseFiles" defaultMessage="Browse Files" />
          <input type="file" multiple onChange={handleFileChange} />
        </label>
      </div>

      <div className="image-preview-container">
        {selectedImages.map((img, index) => (
          <div key={index} className="image-preview">
            <img src={img.preview || img.path} alt="Uploaded Preview" width={140} />
            <button className="removeImg" onClick={() => removeImage(index)}>
              <img src={removeImg} alt="Remove" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DragDropUploader;
